import React from 'react';
import { CURRENCY_OPTIONS } from '../utils/pricing';

function CurrencySelector({ value, onChange, disabled = false }) {
  return (
    <div className="currency-selector">
      <select
        id="preferred-currency"
        className="currency-selector__input"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        aria-label="Currency"
      >
        {CURRENCY_OPTIONS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CurrencySelector;